module.exports = __webpack_public_path__ + "img/jcb.bb02d2b0.png";